module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Light.2cd73177.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Light.ttf
// module id = 2539
// module chunks = 7